import React from 'react';

export const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div>
          <span className="brand-mark" aria-hidden="true" style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: 8, width: 18, height: 18 }} />
          RoadStatic &copy; {year}
        </div>
        <div>Push-to-talk for the road.</div>
      </div>
    </footer>
  );
};
